<template>
  <div>
    <div class="input-group" v-for="(p, index) in prices">
      <div class="input-group-prepend">
        <select style="width: 44px;" v-model="p.qty" :disabled="index === 0" class="form-control">
          <template v-if="index === 0">
            <option value="1">1</option>
          </template>
          <template v-else>
            <option v-for="qty in getAllowedPriceQty(p.qty)" :value="qty">{{ qty }}</option>
          </template>
        </select>
      </div>
      <input type="number" @change="updatePriceMargin" v-model="p.price" class="form-control">
      <div class="input-group-append" v-if="!singlePrice">
        <span class="input-group-text"><strong>{{ p.margin }} %</strong></span>
        <template v-if="index === 0">
          <button @click="() => addNewPrice()" style="width: 41px;" class="btn btn-outline-primary"
                  type="button">+
          </button>
        </template>
        <template v-else>
          <button @click="() => addNewPrice(index)" class="btn btn-outline-warning" type="button">
            <i class="icon-fa icon-fa-trash-o" aria-hidden="true"/>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['prices', 'updateRecords', 'singlePrice'],
  data() {
    return {}
  },
  methods: {
    getAllowedPriceQty(qty = null) {
      let allowedArray = [2, 3, 4, 5, 6, 7, 8, 9, 10];
      let selectedQty = this.prices.map(p => +p.qty);
      if (qty) {
        selectedQty = selectedQty.filter(q => q !== qty);
      }
      return allowedArray.filter((q) => !selectedQty.includes(q))
    },
    addNewPrice(index = null) {
      const prices = [...this.prices];
      if (index === null) {
        const allowedPrices = this.getAllowedPriceQty();
        prices.push({
          qty: allowedPrices[0],
          price: 0,
          site_id: 1,
          margin: 0
        })
      } else {
        delete prices[index];
      }
      this.updateRecords(prices.filter(p => p));
      // this.prices = this.prices.filter(p => p)
    },
    updatePriceMargin() {

    },
  }
}

</script>

<style scoped>
.input-group-append button {
  width: 41px;
}

</style>
